/* unplugin-vue-components disabled */import { render } from "./AnswerQuestion.vue?vue&type=template&id=8a9a5526&scoped=true"
import script from "./AnswerQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerQuestion.vue?vue&type=script&lang=js"

import "./AnswerQuestion.vue?vue&type=style&index=0&id=8a9a5526&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9a5526"]])

export default __exports__